import { DatePipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { Setting } from '@common/interfaces/setting.interface';
import { SettingKeyCodes } from '@common/known-types/setting-key.codes';
import { environment } from '@environments/environment.base';
import { QueryService } from '@services/query.service';

@Pipe({
    name: 'datetime'
})
export class DateTimePipe implements PipeTransform {
    defaultDateFormat: string = environment.settings.input.dateFormat;
    defaultTimeFormat: string = environment.settings.input.timeFormat;
    defaultDateTimeFormat: string = `${this.defaultDateFormat} ${this.defaultTimeFormat}`;
    private datePipe = inject(DatePipe);
    private queryService = inject(QueryService);

    constructor() {
        this.getDefaultDatetimeFormat();
    }

    transform(value: Date | string): string | null {
        return this.datePipe.transform(value, this.defaultDateTimeFormat);
    }

    private getDefaultDatetimeFormat() {
        const settings = this.queryService.queryClient.getQueryData<Setting[]>(['settings']);
        if (!settings) return;
        const defaultDateFormat = settings.find(
            (setting: Setting) => setting.key === SettingKeyCodes.DateFormat
        )?.value;
        if (defaultDateFormat) this.defaultDateFormat = defaultDateFormat;
        const defaultTimeFormat = settings.find(
            (setting: Setting) => setting.key === SettingKeyCodes.TimeFormat
        )?.value;
        if (defaultTimeFormat) this.defaultTimeFormat = defaultTimeFormat;
        this.defaultDateTimeFormat = `${this.defaultDateFormat} ${this.defaultTimeFormat}`;
    }
}
